import { PAYMENT_STATE } from '@apps/redux/features/PayAndReviewSlice'
import { keepOnlyAutoPromo } from '@apps/utils/autoPromo'

/**
 * Payment state to restore when a failed activation is retried.
 *
 * Retry sends the customer back to redo the payment, so what they entered there
 * has to go. PaymentPage's unmount reset does this normally, but it skips
 * activation outcome pages on purpose — zeroing the summary on the way in would
 * wipe the totals the transaction summary renders — so nothing clears it on the
 * way back (MASC-17370).
 *
 * Shared by the consumer and dealer ProcessFailure, which are otherwise
 * near-duplicates: keeping one copy means the two cannot drift.
 */
export const buildRetryResetPayload = ({
  plan,
  multiPromotionCodeInfo = [],
  autoPromoText
} = {}) => ({
  [PAYMENT_STATE.CC_INFO.CREDIT_CARD_NUMBER]: '',
  [PAYMENT_STATE.CC_INFO.EXPIRY_DATE]: '',
  [PAYMENT_STATE.CC_INFO.SECURITY_CODE]: '',
  [PAYMENT_STATE.CC_INFO.POSTAL_CODE]: '',

  // Back to the default the checkbox itself renders. VoucherOptionSection holds
  // its checked state locally as useState(true) and never reads redux, so a
  // retry carrying a false value forward showed the box ticked while the ATU
  // promo was silently refused — the flag and the UI disagreeing.
  [PAYMENT_STATE.AUTO_TOP_UPS]: true,

  [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE]: '',
  [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE_INFO]: '',
  [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE_IS_VALID]: false,
  [PAYMENT_STATE.PROMO.PROMOTION_CODE]: '',
  [PAYMENT_STATE.PROMO.PROMOTION_CODE_INFO]: '',
  [PAYMENT_STATE.PROMO.PROMOTION_VALIDATION_CODE]: '',
  [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE]: '',
  [PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_LOADER]: false,
  [PAYMENT_STATE.PROMO.MULTI_PROMOTION_VALIDATION_CODE]: '',

  // The plan's auto promo is kept: it is not user-entered, and dropping it would
  // silently cost the customer their discount on the retry.
  ...keepOnlyAutoPromo({
    promo: plan?.promo,
    multiPromotionCodeInfo,
    autoPromoText
  })
})

export default buildRetryResetPayload
